import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {useDispatch} from 'react-redux';

const useLockNavigation = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    window.history.pushState(null, '', window.location.href);

    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
    };
    const unblock = history.block(() => {
      return false;
    });

    window.addEventListener('popstate', handlePopState);
    
    return () => {
      window.removeEventListener('popstate', handlePopState);
      unblock();
    };
  }, [dispatch, history, location.pathname]);
}

export default useLockNavigation
